// The tag vocabulary, by name.
//
// Every action, action type and result in the database, so calling code can say
// what it means instead of embedding a number. These IDs are stable in the
// data; what is not stable is a reader's memory of which number means what.
//
// tagVocabulary.test.js asserts these against the database's own wording, so if
// a row is ever renamed or renumbered the tests fail rather than the app
// silently querying the wrong thing.

export const ACTION = {
    Shot:            1,
    Pass:            2,
    Cross:           3,
    Dribble:         4,
    Foul:            5,
    DrawFoul:        6,
    Turnover:        7,
    Saved:           8,
    Assist:          9,
    Interception:    10,
    Clearance:       11,
    Tackle:          12,
    Blocked:         13,
    Deflected:       14,
    HandBall:        15,
    OwnGoal:         16,
    SuperSaved:      17,
    AirChallenge:    18,
    GroundChallenge: 19,
    OneVsOne:        20,
    Card:            21,
    GoalReceived:    22,
};

export const ACTION_TYPE = {
    Right:        1,
    Left:         2,
    Header:       3,
    ShortPass:    4,
    LongPass:     5,
    ThroughPass:  6,
    KeyPass:      7,
    Regular:      8,
    YellowCard:   9,
    RedCard:      10,
    FreeKick:     11,
    Corner:       12,
    Penalty:      13,
    ThrowIn:      14,
    PassForAShot: 15,
    DiagonalPass: 16,
};

export const RESULT = {
    OnTarget:     1,
    OffTarget:    2,
    Goal:         3,
    Successful:   4,
    Turnover:     5,
    Saved:        6,
    Blocked:      7,
    Cleared:      8,
    GoalSaved:    9,
    Unsuccessful: 10,
    BadPass:      11,
    BadDribble:   12,
    FreeKick:     13,
    Penalty:      14,
    Offside:      15,
    DrawFoul:     16,
    Stolen:       17,
    Wide:         18,
    Deflected:    19,
};

// The API takes these as comma-separated strings; null means "no filter".
export const ids = (...values) => (values.length ? values.join(',') : null);

// The database's own wording for each ID, for the drift test.
export const DB_NAMES = {
    'ACTION': {
        '1': 'Shot',
        '2': 'Pass',
        '3': 'Cross',
        '4': 'Dribble',
        '5': 'Foul',
        '6': 'Draw Foul',
        '7': 'Turnover',
        '8': 'Saved',
        '9': 'Assist',
        '10': 'Interception',
        '11': 'Clearance',
        '12': 'Tackle',
        '13': 'Blocked',
        '14': 'Deflected',
        '15': 'Hand-Ball',
        '16': 'Own Goal',
        '17': 'Super Saved',
        '18': 'Air Challenge',
        '19': 'Ground Challenge',
        '20': 'One vs One',
        '21': 'Card',
        '22': 'Goal Received'
    },
    'ACTION_TYPE': {
        '1': 'Right',
        '2': 'Left',
        '3': 'Header',
        '4': 'Short Pass',
        '5': 'Long Pass',
        '6': 'Through Pass',
        '7': 'Key Pass',
        '8': 'Regular',
        '9': 'Yellow Card',
        '10': 'Red Card',
        '11': 'Free Kick',
        '12': 'Corner',
        '13': 'Penalty',
        '14': 'Throw-In',
        '15': 'Pass For a Shot',
        '16': 'Diagonal Pass'
    },
    'RESULT': {
        '1': 'On Target',
        '2': 'Off Target',
        '3': 'Goal',
        '4': 'Successful',
        '5': 'Turnover',
        '6': 'Saved',
        '7': 'Blocked',
        '8': 'Cleared',
        '9': 'Goal Saved',
        '10': 'Unsuccessful',
        '11': 'Bad Pass',
        '12': 'Bad Dribble',
        '13': 'Free Kick',
        '14': 'Penalty',
        '15': 'Offside',
        '16': 'Draw Foul',
        '17': 'Stolen',
        '18': 'Wide',
        '19': 'Deflected'
    }
};
